import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import { generateArticleUrl } from '../../../ui/src/utilities';

const CsmArticleLink = props => {
  const { className, article, children } = props;
  return (
    <Link className={className} to={generateArticleUrl(article)}>
      <div className="row">
        {children && children}
        {article.name && (
          <div className="col-xs-9 col-md-9 col-lg-9 location-small-title">
            {article.name}
          </div>
        )}
      </div>
    </Link>
  );
};

CsmArticleLink.propTypes = {
  article: PropTypes.object.isRequired,
  children: PropTypes.node,
  className: PropTypes.string,
};

export default CsmArticleLink;



// WEBPACK FOOTER //
// ./src/app/component/csmArticleLink/index.js